import { intl } from "i18n/I18nProvider";

export const isPositiveNumber = (value: string) =>
  /^\d*\.?\d+$/.test(String(value)) || intl.formatMessage({ id: 'receipt.input.number.positive' });
